var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _rect4, _rect5, _rect6, _rect7, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _path30, _path31, _path32, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 900",
    preserveAspectRatio: "xMidYMid slice",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sw-wisp1",
    cx: "62%",
    cy: "64%",
    r: "12%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#aaff44",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#66cc22",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#002200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sw-wisp2",
    cx: "38%",
    cy: "70%",
    r: "9%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc44",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#aa8800",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#002200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sw-wisp3",
    cx: "82%",
    cy: "60%",
    r: "7%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#88ff55",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#002200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sw-wisp4",
    cx: "24%",
    cy: "62%",
    r: "8%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ccff44",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#001800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sw-sky",
    cx: "50%",
    cy: "0%",
    r: "90%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#050a04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#060d06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#080e08"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#sw-sky)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "#030803",
    opacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 400,
    fill: "#020503",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,500 Q100,480 200,498 Q300,516 400,490 Q500,464 600,488 Q700,512 800,485 Q900,458 1000,482 Q1100,506 1200,480 Q1300,454 1400,480 Q1500,506 1600,480 L1600,900 L0,900 Z",
    fill: "#060e06",
    opacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,600 Q100,578 200,598 Q300,618 400,592 Q500,566 600,592 Q700,618 800,590 Q900,562 1000,588 Q1100,614 1200,588 Q1300,562 1400,588 Q1500,614 1600,588 L1600,900 L0,900 Z",
    fill: "#050c05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,660 Q120,638 240,658 Q360,678 480,652 Q600,626 720,652 Q840,678 960,650 Q1080,622 1200,648 Q1320,674 1440,648 Q1540,626 1600,645 L1600,900 L0,900 Z",
    fill: "#020802"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,720 Q80,700 160,718 Q240,736 320,710 Q400,684 480,710 Q560,736 640,708 Q720,680 800,706 Q880,732 960,706 Q1040,680 1120,706 Q1200,732 1280,706 Q1360,680 1440,706 Q1530,732 1600,712 L1600,900 L0,900 Z",
    fill: "#040a04",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 900,
    fill: "url(#sw-wisp1)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 900,
    fill: "url(#sw-wisp2)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 900,
    fill: "url(#sw-wisp3)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1600,
    height: 900,
    fill: "url(#sw-wisp4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M560,660 Q558,580 556,520 Q554,460 558,400 Q562,340 560,280 Q560,230 562,180",
    stroke: "#1a1a0a",
    strokeWidth: 8,
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M562,480 Q590,460 620,450 Q650,440 660,420",
    stroke: "#1a1a0a",
    strokeWidth: 5,
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M558,420 Q530,400 510,385 Q495,372 482,355",
    stroke: "#1a1a0a",
    strokeWidth: 4,
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M560,350 Q575,328 595,318 Q615,308 620,290",
    stroke: "#1a1a0a",
    strokeWidth: 3,
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M558,320 Q538,305 524,292 Q510,278 502,260",
    stroke: "#1a1a0a",
    strokeWidth: 3,
    fill: "none"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M560,260 Q572,238 582,220",
    stroke: "#1a1a0a",
    strokeWidth: 3,
    fill: "none"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M560,260 Q548,240 540,220",
    stroke: "#1a1a0a",
    strokeWidth: 2.5,
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M820,660 Q822,575 820,505 Q818,440 820,370 Q822,305 820,240 Q820,195 822,150",
    stroke: "#151505",
    strokeWidth: 10,
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M820,530 Q850,508 876,496 Q900,484 908,460",
    stroke: "#151505",
    strokeWidth: 5,
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M820,460 Q796,440 778,426 Q762,412 750,390",
    stroke: "#151505",
    strokeWidth: 4,
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M820,390 Q840,368 858,352 Q876,336 878,312",
    stroke: "#151505",
    strokeWidth: 4,
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M820,350 Q798,330 784,314 Q772,298 760,278",
    stroke: "#151505",
    strokeWidth: 3,
    fill: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M820,280 Q834,260 848,244 Q860,230 862,208",
    stroke: "#151505",
    strokeWidth: 3,
    fill: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M822,240 Q808,222 800,205",
    stroke: "#151505",
    strokeWidth: 2.5,
    fill: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1060,660 Q1058,595 1056,535 Q1054,475 1058,420 Q1062,365 1060,310 Q1060,265 1062,220",
    stroke: "#121202",
    strokeWidth: 7,
    fill: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1060,500 Q1086,482 1106,470 Q1126,458 1130,436",
    stroke: "#121202",
    strokeWidth: 4,
    fill: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1058,440 Q1038,422 1022,408 Q1008,394 998,372",
    stroke: "#121202",
    strokeWidth: 3.5,
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1060,360 Q1074,340 1088,324 Q1102,308 1104,285",
    stroke: "#121202",
    strokeWidth: 3,
    fill: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1060,310 Q1044,292 1032,276",
    stroke: "#121202",
    strokeWidth: 2.5,
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M260,660 Q258,605 256,555 Q254,505 258,455 Q262,405 260,355 Q260,315 262,275",
    stroke: "#181808",
    strokeWidth: 6,
    fill: "none"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M260,510 Q280,494 298,484 Q316,474 318,454",
    stroke: "#181808",
    strokeWidth: 3.5,
    fill: "none"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M258,450 Q240,434 228,420 Q218,406 208,386",
    stroke: "#181808",
    strokeWidth: 3,
    fill: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M260,380 Q272,362 284,348",
    stroke: "#181808",
    strokeWidth: 2.5,
    fill: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M258,340 Q246,324 238,308",
    stroke: "#181808",
    strokeWidth: 2,
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1340,660 Q1338,605 1336,558 Q1334,510 1338,462",
    stroke: "#141404",
    strokeWidth: 5,
    fill: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1338,560 Q1358,544 1374,534 Q1390,524 1392,506",
    stroke: "#141404",
    strokeWidth: 3,
    fill: "none"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1336,500 Q1318,484 1306,470 Q1296,456 1286,436",
    stroke: "#141404",
    strokeWidth: 2.5,
    fill: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 995,
    cy: 600,
    rx: 180,
    ry: 28,
    fill: "#88dd00",
    opacity: 0.12
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 995,
    cy: 608,
    rx: 120,
    ry: 18,
    fill: "#aaff44",
    opacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 612,
    cy: 660,
    rx: 140,
    ry: 22,
    fill: "#ffcc22",
    opacity: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 612,
    cy: 668,
    rx: 90,
    ry: 14,
    fill: "#ddaa00",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1320,
    cy: 580,
    rx: 100,
    ry: 18,
    fill: "#88dd00",
    opacity: 0.09
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390,
    cy: 640,
    rx: 110,
    ry: 20,
    fill: "#99ee33",
    opacity: 0.08
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 995,
    cy: 600,
    rx: 6,
    ry: 9,
    fill: "#ccff77",
    opacity: 0.85
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 612,
    cy: 656,
    rx: 5,
    ry: 8,
    fill: "#ffee88",
    opacity: 0.75
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1316,
    cy: 578,
    rx: 4,
    ry: 7,
    fill: "#aaff44",
    opacity: 0.7
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 388,
    cy: 638,
    rx: 4,
    ry: 7,
    fill: "#bbff55",
    opacity: 0.65
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 780,
    cy: 680,
    rx: 3,
    ry: 5,
    fill: "#ddff88",
    opacity: 0.5
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1180,
    cy: 640,
    rx: 3,
    ry: 5,
    fill: "#aaffaa",
    opacity: 0.45
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0,760 Q400,730 800,755 Q1200,780 1600,755 L1600,820 Q1200,840 800,816 Q400,792 0,820 Z",
    fill: "#030903",
    opacity: 0.7
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0,800 Q200,782 400,798 Q600,814 800,792 Q1000,770 1200,792 Q1400,814 1600,792 L1600,840 Q1400,860 1200,838 Q1000,816 800,838 Q600,860 400,840 Q200,820 0,840 Z",
    fill: "#040b04",
    opacity: 0.6
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0,840 Q400,820 800,838 Q1200,856 1600,838 L1600,900 L0,900 Z",
    fill: "#020802",
    opacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 380,
    height: 900,
    fill: "#010501",
    opacity: 0.45
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 180,
    height: 900,
    fill: "#010401",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwamp);
export default __webpack_public_path__ + "static/media/swamp.4b6556d4408e3ca44877871bcdb98f46.svg";
export { ForwardRef as ReactComponent };